import { useTranslation } from "react-i18next";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { ResizableWrapper } from "../../shared/components/ResizableWrapper";
import { HtmlEditor } from "./Components/HtmlEditor";
import { PreviewResults } from "./Components/PreviewResults";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { addStorageObject } from "../../app/state/storageObjectSlice/actions/actions";
import styles from "./styles.module.css";

export const Editor = () => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("ai_agents_spa");
  const { t } = useTranslation();

  const handleAddDialogObject = () => {
    dispatch(
      addStorageObject({
        name: t("editor.default_name"),
        service: "ai_agents_spa",
        objectType: "child",
      }),
    ).unwrap();
  };

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("editor.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={handleAddDialogObject}
      />
    );
  }

  return (
    <div className={styles["container"]}>
      <ResizableWrapper
        hasButton={true}
        leftBlock={<HtmlEditor />}
        rightBlock={<PreviewResults />}
        leftBlockSize={40}
        rightBlockSize={60}
        rightBlockMinSize={30}
        leftClassName={styles["editor-resize-wrapper"]}
        rightClassName={styles["previewer-resize-wrapper"]}
      />
    </div>
  );
};
